import { useState } from 'react'
import { useSubscribe } from 'streamr-client-react'
import useIsMounted from '~hooks/useIsMounted'

const DATA_HISTORY_STREAM_ID = '0x7d275b79eaed6b00eb1fe7e1174c1c6f2e711283/DATA-historical-price'

export default function useHistoricalDataTokenStream() {
    const isMounted = useIsMounted()

    const [ranges, setRanges] = useState({
        today: [],
        week: [],
        month: [],
        year: [],
        all: [],
    })

    useSubscribe(DATA_HISTORY_STREAM_ID, {
        onMessage(msg) {
            if (!isMounted()) {
                return
            }

            const {
                todayPoints: today,
                weekPoints: week,
                monthPoints: month,
                yearPoints: year,
                allPoints: all,
            } = msg.getParsedContent()

            setRanges({
                today,
                week,
                month,
                year,
                all,
            })
        },
        resendOptions: {
            last: 1,
        },
    })

    return ranges
}
